import { Injectable } from "@angular/core";
import { IID_FEASABILITY_RESPONSE } from "@common/interfaces/interfaceData";
import { ID } from "@common/interfaces/id";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { PersistedStoreConfig } from "@persistence/persisted-store-config";
import { InterfaceDataStore } from "../interfaceDataRegistry";

export interface IIDFeasabilityResponseState extends EntityState<IID_FEASABILITY_RESPONSE, ID> {}

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_FEASABILITY_RESPONSE , realtimeEntity: 'IID_FeasabilityResponse'})
@InterfaceDataStore(InterfaceName.IID_FEASABILITY_RESPONSE)
export class IIDFeasabilityResponseStore extends EntityStore<IIDFeasabilityResponseState> {
  constructor() {
    super([]);
  }
}
